module.exports = __webpack_public_path__ + "img/SITE WEB - Page Offres d'AlternancePic.b9e6830.png";